import { EmployeeWhole } from '@/types';
import { StandardDate } from '@/types/dates.types';

import { RootState } from '../types';

export const selectFreeDay = (employeeId: EmployeeWhole['id'], date: StandardDate) => (state: RootState) =>
  state.reducer.freeDaysMarking[employeeId]?.[date];
